/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { DefaultLanguage } from 'shared';

import { Organization } from '../../../../types/organization/Organization';

export const validationSchema = Yup.object({
  name: Yup.string().trim().max(50, 'max_length').required('empty'),
  description: Yup.string().trim().max(200, 'max_length'),
  companyName: Yup.string().trim().required('empty'),
  email: Yup.string().trim().email('invalid_email'),
  language: Yup.string().trim().required('empty'),
  vatNumber: Yup.string().nullable().trim(),

  address: Yup.object({
    line1: Yup.string().trim().required('empty'),
    line2: Yup.string().trim().nullable(),
    line3: Yup.string().trim().nullable(),
    postalCode: Yup.string().trim().required('empty'),
    city: Yup.string().trim().required('empty'),
    state: Yup.string().trim().nullable(),
    countryCode: Yup.string().required('empty'),
  }),
});

export const getInitialValues = (organization: Organization) => {
  const orgAddress = organization.address;
  return {
    name: organization.name || '',
    description: organization.description || '',
    email: organization.email || '',
    companyName: organization.companyName || '',
    language: organization.language || DefaultLanguage,
    vatNumber: organization.vatNumber || '',
    thumbnail: null,
    thumbnailsOptions: [],
    address: {
      line1: orgAddress.line1 || '',
      line2: orgAddress.line2 || '',
      line3: orgAddress.line3 || '',
      postalCode: orgAddress.postalCode,
      city: orgAddress.city || '',
      state: orgAddress.state || '',
      countryCode: orgAddress.countryCode || '',
    },
  };
};
